import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import './CrmHelper.css';

const Panel = React.lazy(() => import('./CrmHelperPanel'));
class HelperBoundary extends React.Component {
  state = { failed:false };
  static getDerivedStateFromError() { return { failed:true }; }
  render() {
    return this.state.failed ? <div className="mhc-helper-loading" role="alert">The Coach could not open. Close it and try again.</div> : this.props.children;
  }
}
export default function CrmHelperLauncher({ onSearchRecords }) {
  const location = useLocation();
  const [open,setOpen] = useState(false);
  const [dock,setDock] = useState(null);
  useEffect(() => {
    if (!location.pathname.startsWith('/dochub')) { setDock(null); return undefined; }
    const locate = () => setDock(document.querySelector('[data-mhc-coach-host="dochub"]'));
    locate();
    const observer = new MutationObserver(locate);
    observer.observe(document.body,{childList:true,subtree:true});
    return () => observer.disconnect();
  },[location.pathname]);
  const launcher = useRef(null);
  const close = useCallback(() => { setOpen(false); if (launcher.current) launcher.current.focus(); },[]);
  const search = () => { close(); onSearchRecords(); };
  const helper = <div className={'mhc-helper' + (dock ? ' mhc-helper--docked' : '')}>
    {open && <section id="mhc-helper-panel" className="mhc-helper-panel" role="dialog" aria-modal="false" aria-labelledby="mhc-helper-title" onKeyDown={event => { if(event.key==='Escape'){event.stopPropagation();close();} }}>
      <header className="mhc-helper-head"><div><span className="mhc-helper-eyebrow">YOUR WORKSPACE GUIDE</span><h2 id="mhc-helper-title">AI Coach</h2></div><button type="button" className="mhc-helper-close" aria-label="Close AI Coach" onClick={close}>×</button></header>
      <HelperBoundary><React.Suspense fallback={<p className="mhc-helper-loading" role="status">Opening Coach…</p>}><Panel pathname={location.pathname} onSearchRecords={search} onNavigate={close} /></React.Suspense></HelperBoundary>
    </section>}
    <button ref={launcher} className="mhc-helper-launch" type="button" aria-expanded={open} aria-controls="mhc-helper-panel" onClick={() => open ? close() : setOpen(true)}><span aria-hidden="true">✦</span> AI Coach</button>
  </div>;
  return dock ? createPortal(helper,dock) : helper;
}
